export default "__VITE_ASSET__BiFNNKno__"